import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style/fonts.css';
import './style/variables.css';
import App from './components/tree/App/App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
